import styled from 'styled-components';

import grid from '~/styles/grid';

export const Container = styled.div``;

export const CollapseHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  color: #1a1a1a;
  cursor: pointer;
  display: flex;
  font-size: 114.28%;
  font-weight: 600;
  gap: ${grid.sm};
  padding-bottom: ${grid.sm};
  width: 100%;
`;
